<template>
  <div id="wrapper">

    <div class="normalheader transition">
      <div class="hpanel">
        <div class="panel-body">
          <div id="hbreadcrumb" class="pull-right m-t-lg">
            <ol class="hbreadcrumb breadcrumb">
              <li><router-link :to="{name: 'Projects'}">Projects</router-link></li>
              <li><router-link :to="{name: 'ProjectDetails', params: {id: projectId}}">Project Overview</router-link></li>
              <li><router-link :to="{name: 'MailingReview', params: {project_id: projectId, question_id: questionId}}">Mailing Review</router-link></li>
              <template v-if="mailing && mailing.sent === null">
                <li><router-link :to="{name: 'Mailing', params: {project_id: projectId, question_id: questionId, mailing_id: mailingId}}">Mailing</router-link></li>
                <li><router-link :to="{name: 'MailingExpertSelection', params: {project_id: projectId, question_id: questionId, mailing_id: mailingId}}">Mailing Expert</router-link></li>
              </template>
              <li class="active">Summary</li>
            </ol>
          </div>
          <h3 class="font-light m-b-xs" v-if="project">
            Mailing - <router-link class="font-bold text-info" :to="{name: 'ProjectDetails', params: {id: projectId}}">{{project.name}}</router-link>
          </h3>
          <small>Final review before sending</small>
        </div>
      </div>
    </div>

    <div class="content">

      <div class="hpanel no-margins" v-if="mailing">

        <div class="panel-heading">
          Mailing texts
        </div>

        <div class="row">
          <div class="col-xs-12 col-md-6">
            <div class="hpanel">

              <div class="panel-heading hbuilt">
                Experts added through the platform
              </div>

              <div class="panel-body">
                <div>
                  <label>Subject</label>
                  <div v-html="mailing.template.subject"></div>
                </div>
                <div style="margin-top: 15px">
                  <label>Text body</label>
                  <div v-html="mailing.template.body"></div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-xs-12 col-md-6">

            <div class="hpanel">

              <div class="panel-heading hbuilt">
                Manually added experts
              </div>

              <div class="panel-body">
                <div>
                  <label>Subject </label>
                  <div v-html="mailing.template.subject_manual"></div>
                </div>
                <div style="margin-top: 15px">
                  <label>Text body</label>
                  <div v-html="mailing.template.body_manual"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-12">

            <div class="hpanel">

              <div class="panel-heading hbuilt">
                Mailing for Organisations
              </div>

              <div class="panel-body">
                <div>
                  <label>Subject </label>
                  <div v-html="mailing.template.subject_organisation"></div>
                </div>
                <div style="margin-top: 15px">
                  <label>Text body</label>
                  <div v-html="mailing.template.body_organisation"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="hpanel">

        <div class="panel-heading">
          Selected experts
        </div>

        <div class="panel-body">
          <experts-list-selection :experts="experts"/>
        </div>

        <div class="panel-heading">
          Selected organisations
        </div>

        <div class="panel-body">
          <companies-list-selection :companies="companies"/>
        </div>

      </div>

      <div class="hpanel" v-if="mailing">
        <div class="panel-heading">
          Actions
        </div>
        <div class="panel-body text-center">
          <template v-if="mailing.sent === null">
            <div class="col-xs-4 border-right">
              <router-link class="btn btn-info" :to="{name: 'MailingReview', params: {project_id: projectId, question_id: questionId}}"><i class="fa fa-arrow-left"></i> Back to Contact Overview</router-link>
            </div>
            <div class="col-xs-4 border-right">
              <button class="btn btn-danger" data-toggle="modal" data-target="#modalDeleteMailing"><i class="fa fa-trash"></i> Delete mailing</button>
            </div>
            <div class="col-xs-4 border-right">
              <button class="btn btn-info" data-toggle="modal" data-target="#modalSendMailing"><i class="fa fa-paper-plane"></i> Send mailing</button>
            </div>
          </template>
          <template v-else>
            <div class="col-xs-12">
              <router-link class="btn btn-info " :to="{name: 'MailingReview', params: {project_id: projectId, question_id: questionId}}"><i class="fa fa-arrow-left"></i> Back to mailing review</router-link>
            </div>
          </template>
        </div>
      </div>

    </div>

    <div class="modal fade hmodal-success" id="modalSendMailing" tabindex="-1" role="dialog"  aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="color-line"></div>
          <div class="modal-header">
            <h4 class="modal-title">Send Mailing</h4>
          </div>
          <div class="modal-body">
            <h3>Are you sure you want to send this mailing ?</h3>
            <template v-if="sendMailingError !== null">
              <div v-if="sendMailingError === 1" class="text-danger">
                <div>Your mail account doesn't authorised for send a mailing</div>
                <div class="m-t-xs">To authorize your account you must transfer us the mail of our provider (mailjet)</div>
                <div class="m-t-xs">You can transfer this email to support@idxlab.com</div>
              </div>
              <div v-else-if="sendMailingError === 2" class="text-danger">
                <div>As is your first mailing, your mail account needs to be authorised by our mail provider</div>
                <div class="m-t-xs">To authorize your account you must transfer us the mail of our provider (mailjet)</div>
                <div class="m-t-xs">You can transfer this email to support@idxlab.com</div>
              </div>
            </template>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal" >Cancel</button>
            <vue-ladda type="submit" :loading="submit.loading" class="btn btn-info" :data-style="submit.dataStyle" v-on:click="sendMailing">Confirm</vue-ladda>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade hmodal-danger" id="modalDeleteMailing" tabindex="-1" role="dialog"  aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="color-line"></div>
          <div class="modal-header">
            <h4 class="modal-title">Delete Mailing</h4>
          </div>
          <div class="modal-body">
            <h3>Are you sure you want to delete this mailing ?</h3>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal" >Cancel</button>
            <vue-ladda type="submit" :loading="submit.loading" class="btn btn-danger" :data-style="submit.dataStyle" v-on:click="deleteMailing">Confirm</vue-ladda>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import VueLadda from 'vue-ladda'
import ExpertsListSelection from '../../components/companyAuthor/ExpertsSelection'
import CompaniesListSelection from '../../components/companyAuthor/CompaniesSelection'

export default {
  components: {
    CompaniesListSelection,
    ExpertsListSelection,
    VueLadda},
  props: [],
  name: 'MailingSummary',
  methods: {
    getResources: function () {
      this.axios.get('/question/' + this.questionId)
        .then((response) => {
          this.question = response.data

          this.question.mailing.forEach((mailing) => {
            if (mailing.id === this.mailingId) {
              this.mailing = mailing
              mailing.authors.forEach((item) => {
                let isCompany = [6].find((source) => item.source_id === source && item.firstName === null)
                if (typeof isCompany !== 'undefined') {
                  this.companies.push(item)
                } else {
                  this.experts.push(item)
                }
              })
            }
          })
        }).catch((error) => {
          if (error.response.status === 403) {
            this.$router.replace({name: 'Error403', params: {'0': ''}})
          }
          if (error.response.status === 404) {
            this.$router.replace({name: 'Error404', params: {'0': ''}})
          }
        })

      this.axios.get('/project/' + this.projectId)
        .then((response) => {
          this.project = response.data
        }).catch((error) => {
          if (error.response.status === 403) {
            this.$router.replace({name: 'Error403', params: {'0': ''}})
          }
          if (error.response.status === 404) {
            this.$router.replace({name: 'Error404', params: {'0': ''}})
          }
        })
    },
    sendMailing: function () {
      this.submit.loading = true
      this.sendMailingError = null

      this.axios.get('/mailing/' + this.mailingId + '/checkSender').then(() => {
        this.axios.post('/mailing/' + this.mailingId + '/send')
          .then((response) => {
            $('#modalSendMailing').modal('hide')
            this.$router.push({name: 'MailingReview', params: {project_id: this.projectId, question_id: this.questionId}})
          }).catch(function (error) {
          }).finally(() => {
            $('#modalSendMailing').modal('hide')
            this.submit.loading = false
          })
      }).catch((error) => {
        this.sendMailingError = error.response.data.code
      }).finally(() => {
        this.submit.loading = false
      })
    },
    deleteMailing: function () {
      this.submit.loading = true
      this.axios.delete('/mailing/' + this.mailingId)
        .then((response) => {
          $('#modalDeleteMailing').modal('hide')
          this.$router.push({name: 'MailingReview', params: {project_id: this.projectId, question_id: this.questionId}})
        }).catch(function (error) {
        }).finally(() => {
          $('#modalDeleteMailing').modal('hide')
          this.submit.loading = false
        })
    }

  },
  watch: {
  },
  data () {
    return {
      projectId: null,
      questionId: null,
      mailingId: null,
      mailing: null,
      question: null,
      experts: [],
      companies: [],
      project: null,
      sendMailingError: null,
      submit: {
        loading: false,
        'dataStyle': 'zoom-in'
      }
    }
  },
  mounted () {
  },
  beforeMount () {
    this.projectId = parseInt(this.$route.params.project_id)
    this.questionId = parseInt(this.$route.params.question_id)
    this.mailingId = parseInt(this.$route.params.mailing_id)

    this.getResources()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/mailing/MailingSummary.vue